<template>
  <v-app dark>
    <v-container class="fill-height login" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-toolbar color="blue-grey" class="justify-center">
              <v-spacer />
              <img
                src="https://app.applysys.com.br/img/applysys-logotipo.png"
                height="40"
              />
              <v-spacer></v-spacer>
            </v-toolbar>
            <ApolloMutation
              :mutation="login"
              :variables="{ username, password }"
              @done="onDone"
            >
              <template slot-scope="{ mutate, loading, error }">
                <v-card-text>
                  <v-alert type="error" v-if="error">{{ error }}</v-alert>
                  <v-form>
                    <v-text-field
                      label="Login"
                      name="login"
                      prepend-icon="person"
                      type="text"
                      autocomplete="login"
                      v-model="username"
                    ></v-text-field>

                    <v-text-field
                      id="password"
                      label="Password"
                      name="password"
                      prepend-icon="lock"
                      type="password"
                      autocomplete="current-password"
                      v-model="password"
                    ></v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <a
                    @click.prevent="forgotPassword()"
                    color="blue-grey"
                    dark
                    :disabled="loading"
                    
                    >Esqueci minha senha</a
                  >
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue-grey"
                    dark
                    :disabled="loading"
                    @click="mutate()"
                    >Entrar</v-btn
                  >
                </v-card-actions>
                <v-footer>
                  <div class="text-caption">
                    Versão {{ version }} {{ type }}
                  </div>
                  <v-spacer></v-spacer>
                  <div>&copy; ApplySys {{ new Date().getFullYear() }}</div>
                </v-footer>
              </template>
            </ApolloMutation>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { Action } from "../../store/auth/types";
import gql from "graphql-tag";
export default {
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
      type: process.env.VUE_APP_TYPE,
      username: null,
      password: null,
      login: gql`
        mutation Login($username: String!, $password: String!) {
          adminLogin(arg1: { password: $password, username: $username }) {
            accessToken
            user
          }
        }
      `
    };
  },
  methods: {
    // userLogin: function() {
    //   const { username, password } = this.$data;
    //   this.$store.dispatch(`${Action.LOGIN}`, {username, password})
    //   .then(()=>this.$router.push({ path: "/home" }))
    // }
    onDone: function(result) {
      //console.log(result.data.adminLogin.accessToken);
      this.$store
        .dispatch(`${Action.LOGIN}`, {
          token: result.data.adminLogin.accessToken,
          user: result.data.adminLogin.user
        })
        .then(() => this.$router.push("/home", () => this.$router.go(0)));
    },
    forgotPassword() {
      this.$router.push("/resetar-senha", () => this.$router.go(0));
    }
  }
};
</script>

<style lang="stylus">
.login
  background url('https://www.applysys.com.br/crm/files/system/sigin-background-image.jpg') top center no-repeat
  background-size cover
  background-color black
</style>
